import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiMail,
  FiMapPin,
  FiInstagram,
  FiLinkedin,
} from "react-icons/fi";

import { FaTiktok } from "react-icons/fa6";
import { FaBehance } from "react-icons/fa";
import "./Footer.css";

const navigationLinks = [
  { label: "Home", path: "/" },
  { label: "Work", path: "/work" },
  { label: "Services", path: "/services" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

const services = [
  "Creative Strategy",
  "Film Production",
  "Content Creation",
  "Photography",
  "Post Production",
  "Brand Storytelling",
];

const socialLinks = [
  {
    label: "Instagram",
    url: "https://instagram.com",
    icon: FiInstagram,
  },
  {
    label: "LinkedIn",
    url: "https://linkedin.com",
    icon: FiLinkedin,
  },
  {
    label: "Behance",
    url: "https://behance.com",
    icon: FaBehance,
  },
   {
    label: "TikTok",
    url: "https://tiktok.com",
    icon: FaTiktok,
  },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow" />

      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="navbar-logo">
              <div className="etoe-brand">
                <div className="etoe-symbol">
                  <span className="etoe-letter etoe-e">
                    <i className="e-top" />
                    <i className="e-middle" />
                    <i className="e-bottom" />
                  </span>

                  <span className="etoe-letter etoe-t">
                    <i className="t-top" />
                    <i className="t-stem" />
                  </span>

                  <span className="etoe-letter etoe-o" />

                  <span className="etoe-letter etoe-e">
                    <i className="e-top" />
                    <i className="e-middle" />
                    <i className="e-bottom" />
                  </span>
                </div>

                <span className="etoe-productions">PRODUCTIONS</span>
              </div>
            </Link>

            <p>
              A creative production company building strategic, cinematic and
              memorable visual experiences for ambitious brands.
            </p>
          </div>

          <div className="footer-navigation">
            <div className="footer-column">
              <span className="footer-column-title">NAVIGATION</span>

              <nav>
                {navigationLinks.map((link) => (
                  <Link
                    to={link.path}
                    key={link.label}
                    className="footer-link"
                  >
                    <span>{link.label}</span>
                    <FiArrowRight className="footer-navigation-arrow" />
                  </Link>
                ))}
              </nav>
            </div>

            <div className="footer-column">
              <span className="footer-column-title">SERVICES</span>

              <div className="footer-services">
                {services.map((service) => (
                  <span key={service}>{service}</span>
                ))}
              </div>
            </div>

            <div className="footer-column">
              <span className="footer-column-title">CONNECT</span>

              <div className="footer-contact">
                <a
                  href="mailto:info@etoeproduction.com"
                  className="footer-contact-item footer-contact-link"
                >
                  <span className="footer-contact-icon">
                    <FiMail />
                  </span>

                  <span>info@etoeproductions.com</span>
                </a>

                <div className="footer-contact-item footer-location">
                  <span className="footer-contact-icon">
                    <FiMapPin />
                  </span>

                  <span>UAE / India</span>
                </div>
              </div>

              <div className="footer-socials">
                {socialLinks.map((social) => {
                  const Icon = social.icon;

                  return (
                    <a
                      href={social.url}
                      key={social.label}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="footer-social-content">
                        <span className="footer-social-icon">
                          <Icon />
                        </span>

                        <span>{social.label}</span>
                      </span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {currentYear} ETOE PRODUCTIONS</span>

          <div className="footer-legal">
            <Link to="/privacy">PRIVACY POLICY</Link>
            <Link to="/terms">TERMS</Link>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;